import { type UploadSize } from "@components/atoms/Upload";
import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonContentsRenderType, type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";
import { V2EventUpdateRequestDtoCategory as EventCategory } from "@everon-it/api-client/contents-gw";

export type ChargerDetailInitValuesType = {
    title: string;
    isVisible: boolean;
    thumbnailUrl: string;
    contentCategory: EventCategory;
    content: string;
};

export type ChargerCommonContentsOptionType = {
    placeholder?: string;
    isSizeQuestion?: boolean;
    size?: UploadSize;
} & CommonContentsRenderType;

export const ChargerDetailData: CommonDataType<CommonCreateBodyKeyType, ChargerDetailInitValuesType, ChargerCommonContentsOptionType> = {
    createBodyKey: ["title", "isVisible", "thumbnailUrl", "content"],
    formInitialValues: {
        title: "",
        isVisible: false,
        thumbnailUrl: "",
        contentCategory: EventCategory.CONTENT,
        content: "",
    },
    contentsOption: [
        {
            label: "노출 상태",
            name: "isVisible",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "제목",
            name: "title",
            type: CommonElementType.INPUT,
            placeholder: "제목을 입력해주세요",
        },
        {
            label: "썸네일 이미지",
            name: "thumbnailUrl",
            type: CommonElementType.IMAGE_UPLOAD,
            size: "xsmall",
            isSizeQuestion: true,
        },
    ],
};
